<template lang="pug">
  section
    custom-header
    .section.main-section
      transition.is-hidden-mobile(name="slideLeft")
        //- Desktop Sidebar Collapse
        a.collapse-sidebar.is-hidden-mobile(@click="isHiddenDesktop = !isHiddenDesktop" v-bind:class="{'pulled': !isHiddenDesktop}")
          b-icon(size="is-large" v-bind:icon="isHiddenDesktop ? 'keyboard_arrow_right' : 'keyboard_arrow_left'")

      .columns
        transition(name="slideLeft")
          aside.column.is-2(v-show="!isHiddenDesktop")
            sidebar
        section.column.main-content
          transition(name="fade")
            router-view
    custom-footer
</template>

<script>
  import sidebar from './Sidebar'
  import header from './Header'
  import footer from './Footer'

  import AuthService from '@/services/auth.js'

  export default {
    components: {
      sidebar,
      customHeader: header,
      customFooter: footer
    },
    name: 'layout',
    data () {
      return {
        isHiddenDesktop: false,
        user: {}
      }
    },
    beforeRouteEnter (to, from, next) {
      AuthService.getAuthUser()
      .then(response => {
        next(vm => {
          vm.user = response
        })
      })
      .catch(response => {
        AuthService.logout()
        .then(() => {
          const err = new Error(JSON.stringify({next: {name: 'Auth'}, label: 'Autenticação expirada.'}))
          return next(err)
        })
      })
    }
  }
</script>

<style lang="sass" scoped>
  @import "~@/assets/sass/common.sass"
  .main-content
    height: 100%
    padding-top: 5rem
    +desktop
      padding-top: 2rem
  .main-section
    padding-top: 0
  .collapse-sidebar.pulled
    position: relative
    left: 13%
</style>



// WEBPACK FOOTER //
// Layout.vue?9c4960f6